export default function () {
  return {
    countCells: 9,
    massive: [
      ////////////////////////////////////////////////////// вторая строка хэдера

      {
        dataField: 'region',
        cols: 1,
        rows: 2,
        text: 'Субъекты Российской Федерации',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end table-header-info',
        headerStyles: `min-width: 305px; `,
        order: 0,
        variable: true,
      },
      {
        dataField: '2',
        cols: 2,
        rows: 1,
        order: 5,
        variable: false,
        headerClass: 'text-center border-bottom-zero',
        text: 'КЦП прошлых периодов\n',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 2,
        order: 2,
        variable: true,
        headerClass: 'header-table-cell table-header-info',
        headerStyles: `padding: 8px 15px 8px 0 !important;`,
        text: `Потребность в&nbsp;подготовке кадров на&nbsp;долгосрочный период`,
      },
      {
        dataField: 'kcp1',
        cols: 1,
        rows: 2,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell  table-header-info',
        class: '',
        text: 'Прогнозируемый объем КЦП на 2025/26 учебный год',
        // text: '2024 год',
        headerStyles: `padding: 8px 15px 8px 0 !important;`,
      },
      {
        dataField: 'maxPp',
        cols: 1,
        rows: 2,
        order: 13,
        variable: true,
        headerClass: ' header-table-cell  table-header-info',
        class: '',
        text: 'Максимально возможный прием образовательными организациями региона',
        // text: '2024 год',
        headerStyles: `padding: 8px 15px 8px 0 !important;`,
      },
      {
        dataField: 'startValueStage3',
        cols: 1,
        rows: 2,
        order: 14,
        variable: true,
        class: '',
        headerClass: ' header-table-cell table-header-info ',
        text: 'Предложение Субъекта Российской Федерации',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'kcp4',
        cols: 1,
        rows: 2,
        order: 14,
        variable: true,
        class: '',
        headerClass: ' header-table-cell table-header-info ',
        text: 'Головной ЦО',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'kcp44',
        cols: 1,
        rows: 2,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        text: 'ЦО',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'pvFirstSubject',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: 'pvFirstSubjectJc ',
        headerClass: 'table-header-info ',
        headerStyles: `justify-content: flex-start`,
        text: '2023',
      },
      {
        dataField: 'pvSecondSubject',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: 'pvSecondSubjectJc ',
        headerClass: 'table-header-info',
        text: '2024',
      },

    ],

    rowsMassive: [ // строки таблицы
      {
        dataField: 'region',
        cols: 1,
        rows: 1,
        // text: 'Регионы',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end ',
        headerStyles: `min-width: 305px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => `<div class="${r.regionId ? 'pl-7' : r.districtId ? `pl-3` : `font-weight-600`}">${r?.regionName}</div>`
      },
      {
        dataField: 'kcp23',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: '',
        headerStyles: `justify-content: flex-start`,
        // text: '2022',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp23, !r.regionId)
      },
      {
        dataField: 'kcp24',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' ',
        // text: '2023 ',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp24, !r.regionId)
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 1,
        order: 2,
        variable: true,
        styles: 'justify-content: unset;',
        // text: `Потребность в подготовке кадров на долгосрочный период`,
        template: (r) => `${r.ppText ?? ''}` //this.$scripts.TableJs.formatValueInCell(r.pv, !r.regionId) +
      },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        class: '',
        // text: '2024 год',
        styles: 'justify-content: unset;',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValue, !r.regionId)
      },
      {
        dataField: 'maxPp',
        cols: 1,
        rows: 1,
        order: 2,
        variable: true,
        styles: 'justify-content: unset;',
        // text: `Потребность в подготовке кадров на долгосрочный период`,
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.maxPp, !r.regionId)
      },
      {
        dataField: 'startValueStage3', //Субъект РФ
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
        // template: (r) => this.$scripts.TableJs.formatValueInCell(r.stage2Value, !r.regionId)
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValueStage3, !r.regionId)
      },
      {
        dataField: 'stage3Value', //Головной ЦО
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'value', //ЦО
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell',
        styles: 'justify-content: unset;',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
    ]
  }
}